import DialogEx from './src/dialogex.vue';

DialogEx.install = function (Vue) {
    Vue.component(DialogEx.name, DialogEx);
};

export default DialogEx;